import selfHtml from './s950-endorse.html' with { type: 'text' };
import templateHtml from './t01-avatars.html' with { type: 'text' };

import { decrypt_gpg, get_pub_key, pubkey_exists, add_pub_key, sign_gpg, encrypt_gpg, is_my_pubkey } from "../crypt_helper.js"
import { postData, showOffcanvas, navbar_active_menu, spinner_main_window, form_validate, sha256ToMod, getUserAvatar, styleAvatar } from "../utils.js";
import { BASEURL, mod_loader, MsgReadModule } from "../AppState.js"
import secrets from "../lib/secrets.js";

const users = []             // each entry: { email: string, fullname: string }
const endorsements = [];     // For the Tally
const endorsers = new Set(); // Endorsed by
const set_sss_share = new Set();    // The Shamir shares needed to rebuild the PGP encryption key
var btnEndorse;
var btnSSSopen;
var lstEndorseFieldset;
var quorum_min_threshold;
var my_sss_share = null;       // The secrete share of SSS https://en.wikipedia.org/wiki/Shamir%27s_secret_sharing


var root;

export async function init(module_root, args) {
    module_root.innerHTML = selfHtml;
    root = module_root;

    $e(root).getEl("templates_container").innerHTML = templateHtml;

    lstEndorseFieldset = $e(root).getEl("lstEndorseFieldset");
    btnEndorse = $e(root).getEl("btnEndorse");
    btnSSSopen = $e(root).getEl("btnSSSopen");

    const args_payload = args.shares_payload;
    const sss_hex = args.sss_hex;

    const my_pub_key = await get_pub_key();
    quorum_min_threshold = args_payload.quorum_min_threshold;
    $e(root).getEl("quorum_min_threshold").textContent = quorum_min_threshold;
    $e(root).getEl("quorum_total_shares").textContent = args_payload.shares.length;

    for (const k in args_payload.shares) {
        const encrypted_share = {
            armoured_text: args_payload.shares[k].armoured_share,
            pgp_pubkey: args.apishare_response.pgp_pubkey,
        }
        const pk = await get_pub_key(args_payload.shares[k].rcpt_pubkey);

        const user = getUserAvatar(pk);

        await decrypt_gpg(encrypted_share, true).then(async (decrypted) => {
            if (decrypted.success == true) {
                if (my_sss_share != null)
                    throw ("Error: my_sss_share was already defined!")
                my_sss_share = decrypted.message;
                users.unshift(user); // first position is the current (logged-in) user
            } else {
                users.push(user);
            }
        });
    }

    async function get_endorsements() {

        const payload_get_sss = { hkey: sss_hex + "_sss", signature: null }

        const data = await postData(BASEURL.api + '/share_note', payload_get_sss);

        root.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });

        const encrypted_shares = await JSON.parse(data.armoured_text)

        if (encrypted_shares == null)
            return;

        // Trying to decrypt PGP messages that contain the endorsements (additional shares).
        // The shares were initially assigned to the individual members.
        // Some PGP messages (endorsements) are for other recipients, and some PGP messages are for this user.
        // If this user can read enough shares, them the message can be finally decrypted



        for (const share_4_multiple_rcpt of encrypted_shares)
            await decrypt_gpg(share_4_multiple_rcpt, true).then(async (decrypted) => {
                const sender = await get_pub_key(share_4_multiple_rcpt.pgp_pubkey);

                // Find the endorsements that were already submitted by me, and disable the checkbox 
                if (sender.myKeyPairFingerprint == my_pub_key.myKeyPairFingerprint) {
                    console.log("FROM ME!");
                    console.log(share_4_multiple_rcpt.recipient_pub_keys_array)
                    for (const rcpt_key of share_4_multiple_rcpt.recipient_pub_keys_array) {
                        users.find(x => x.pgp_pubkey === rcpt_key).already_endorsed = true;
                    }
                }

                // Show my received endorsements
                if (decrypted.success == true) {
                    console.log("decrypted SHARE", decrypted, sender.myKeyPairUserID[0]);
                    set_sss_share.add(decrypted.message); // first position is the current (logged-in) user
                    endorsers.add(getUserAvatar(sender))
                }

                for (const rcpt of share_4_multiple_rcpt.recipient_pub_keys_array) {
                    const endorsed = await get_pub_key(rcpt);
                    endorsements.push({ sender, endorsed });
                }

            });

        // Check if Quorum is met
        if (set_sss_share.size +1 < quorum_min_threshold)
            $e(root).getEl("textSSSrequirement").classList.remove("d-none");
        else
            btnSSSopen.classList.remove("d-none");

        console.log(users);
        console.log(endorsements);
        console.log(set_sss_share);
    } // end get_endorsements()



    function renderEndorseList() {
        lstEndorseFieldset.textContent = ""; // removes the HTML spinner
        const tpl = $e(root).getEl("tpl-endorse-row");

        for (const u of users) {
            if (u.pgp_pubkey == my_pub_key.myKeyPairPublicKey)
                continue;
            const node = tpl.content.cloneNode(true);
            const label = node.querySelector("label");
            const checkbox = node.querySelector("input");

            checkbox.disabled = u.already_endorsed;
            checkbox.checked = u.already_endorsed;
            checkbox.value = u.already_endorsed ? "" : u.pgp_pubkey;

            styleAvatar(node.querySelector(".avatar"), u, 36);
            node.querySelector(".name").textContent = u.fullname;

            checkbox.addEventListener("change", () => {
                updateSubmitBtn();
            });

            lstEndorseFieldset.appendChild(node);
        }

        //const partecipants = users.filter(x => endorsements[x.pgp_pubkey] === u.pgp_pubkey);

        const k = users.filter(u => u.already_endorsed !== true).length;
        console.log("k", k);
    }

    function updateSubmitBtn() {
        for (const k of lstEndorseFieldset.querySelectorAll("input"))
            if (k.value != "" || k.checked == false)
                return

        btnEndorse.textContent = "All endorsed";
        btnEndorse.classList.replace("btn-primary", "btn-outline-primary");
        btnEndorse.disabled = true;

    }

    function renderTally() {
        const tbody = $e(root).getEl("tallyBody");
        tbody.textContent = "";
        const tpl = $e(root).getEl("tpl-tally-row");

        for (const u of users) {
            //const partecipants = users.filter(x => endorsements[x.pgp_pubkey] === u.pgp_pubkey);
            const node = tpl.content.cloneNode(true);

            styleAvatar(node.querySelector(".avatar"), u, 28);
            node.querySelector(".name").textContent = u.fullname;
            node.querySelector(".name").classList.add(u.pgp_pubkey == my_pub_key.myKeyPairPublicKey ? "fw-medium" : "fw-light");

            const countEl = node.querySelector(".count");

            var counter = 0;
            const supporters = [];
            for (const e of endorsements) {
                if (e.endorsed.myKeyPairPublicKey == u.pgp_pubkey) {
                    counter++;
                    supporters.push(e.sender.myKeyPairUserID[0])
                    console.log("TODO: Endorsed by:" + u.fullname + " : " + e.sender.myKeyPairUserID[0])
                }
            }

            countEl.textContent = counter;
            countEl.className = supporters.length >= quorum_min_threshold
                ? "count badge rounded-pill bg-primary"
                : "count badge rounded-pill bg-secondary bg-opacity-25 text-secondary";

            $e(node).getEl("supporters").textContent =
                supporters.length ? supporters.join(", ") : "—";

            tbody.appendChild(node);
        }
    }

    function render() {
        renderEndorsedBy();
        renderEndorseList();
        updateSubmitBtn();
        renderTally();
    }

    // ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- 

    btnSSSopen.addEventListener("click", async (ev) => {

        console.log("set_sss_share", set_sss_share);
        const arr_shares = Array.from(set_sss_share);
        arr_shares.push(my_sss_share);
        console.log("arr_shares", arr_shares)
        const comb = secrets.combine(arr_shares);
        console.log("comb", comb);
        args_payload.secret_PSK = comb;
        args_payload.armoured_text = args_payload.body;

        MsgReadModule.init_read_message_quorum(ev, args_payload);

    });

    // ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- 

    btnEndorse.addEventListener("click", async (ev) => {

        ev.preventDefault(); // always block default submit
        // ev.stopPropagation();

        console.log(my_sss_share);

        const recipient_pub_keys_array = [];

        var no_endorse_flag = true;
        // give my share to selected participants

        for (const k of lstEndorseFieldset.querySelectorAll("input")) {
            if (k.value == "")
                continue;

            if (k.checked === false)
                k.setCustomValidity("Please select at least one option");
            else {
                no_endorse_flag = false;
                recipient_pub_keys_array.push(k.value);
                users.find(x => x.pgp_pubkey === k.value).already_endorsed = true;  // needed for the EndorseMembers checkboxes()
                endorsements.push({ sender: await get_pub_key(), endorsed: await get_pub_key(k.value) }); // for the Tally
            }
        }

        if (no_endorse_flag) {
            console.log("reportValidity")
            return $e(root).getEl("formEndorse").reportValidity();
        }

        const share_4_multiple_rcpt = await encrypt_gpg(my_sss_share, null, recipient_pub_keys_array);

        const new_share = { armoured_text: share_4_multiple_rcpt, pgp_pubkey: my_pub_key.myKeyPairPublicKey, recipient_pub_keys_array };

        const payload = {
            armoured_text: JSON.stringify(new_share),
            pgp_pub_rcpt: null,
            ttl: "2w",
            pgp_pubkey: my_pub_key.myKeyPairPublicKey,
            autodestruct: false,
            notify_sender_on_intended: false,
            notify_sender_on_fail: false,
            sss_hex,
        }

        console.log("Uploading : TODO: spinner:", sss_hex);

        lstEndorseFieldset.disabled = true;
        const data = await postData(BASEURL.api + '/post_note', payload, ev.target);
        lstEndorseFieldset.disabled = false;

        renderEndorseList();
        updateSubmitBtn();
        renderTally();

    });

    await get_endorsements();
    render();
} // End of .init()

// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

function renderEndorsedBy() {
    const container = $e(root).getEl("endorsedBy");
    container.textContent = "";

    if (endorsers.length === 0) {
        const msg = document.createElement("span");
        msg.className = "text-secondary fst-italic";
        msg.style.fontSize = "14px";
        msg.textContent = "No endorsements yet";
        container.appendChild(msg);
        return;
    }

    const tpl_endorser = $e(root).getEl("tpl-badge-endorser");
    endorsers.forEach(u => {
        const node = tpl_endorser.content.cloneNode(true);
        const badge = node.querySelector("span.badge");
        badge.style.background = "#f0f4ff";
        badge.style.color = "#1a1a2e";
        styleAvatar(node.querySelector(".avatar"), u, 22);
        node.querySelector(".name").textContent = u.fullname;
        container.appendChild(node);
    });
}

// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----
